import { pantryColors } from '@pantry/ui'
import React from 'react'

const p = pantryColors

// Visual treatment mirrors the HTML's `--accent-light` / `--accent-mid` info
// card (docs/pantry/2026.05.27/breadstack-loyalty-pro.html, lines 988–998).
// Kept blue rather than gray so it reads as "informational" next to the
// surrounding form fields.
const card: React.CSSProperties = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: 10,
  padding: '14px 16px',
  background: p.blue[50],
  border: `1px solid ${p.blue[200]}`,
  borderRadius: 8,
  fontSize: 12.5,
  color: p.gray[700],
}

const InfoIcon: React.FC = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke={p.blue[700]}
    strokeWidth="2"
    style={{ flexShrink: 0, marginTop: 1 }}
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="10" />
    <path d="M12 8v4M12 16h.01" />
  </svg>
)

/**
 * "All Products" tab body for the coupon modal's Applies-to section.
 *
 * Informational only — the coupon applies storewide whenever this tab is
 * active. The category / product pickers stay empty on the wire (the Cova
 * adapter sends `applied_to: 'all_products'`).
 */
export const CouponModeAll: React.FC = () => (
  <div style={card}>
    <InfoIcon />
    <div>
      <strong style={{ color: p.gray[800] }}>
        Applies storewide to every product.
      </strong>{' '}
      Use restrictions below to narrow scope (exclude sale items, set a minimum
      order, cap usage, etc.).
    </div>
  </div>
)
